import { UnregisterToEventDto, UpdateEventDto } from '@smatchy/sdk';

export class LoadByIdEventAction {
  static readonly type = '[DetailEvents] LoadByIdEventAction';

  /**
   * @param payload the activity id
   * @param redirectIfMissing whether a missing activity should send the person
   *   away. True for a screen that exists to show that activity: there is
   *   nothing left to display. False for a screen that merely wants a detail
   *   about it, such as a conversation reading the end date, where the activity
   *   being gone is not a reason to close what the person opened.
   */
  constructor(public payload: string, public readonly redirectIfMissing = true) {}
}

export class EditEventByIdAction {
  static readonly type = '[DetailEvents] EditEventByIdAction';

  constructor(public payload: { id: string; data: Partial<UpdateEventDto> }) {}
}

export class SubscribeToEventAction {
  static readonly type = '[DetailEvents] SubscribeToEventAction';

  constructor(public eventId: string) {}
}

export class UnsubscribeToEventAction {
  static readonly type = '[DetailEvents] UnsubscribeToEventAction';

  constructor(
    public eventId: string,
    public readonly reason: UnregisterToEventDto.ReasonEnum,
    public readonly nextOwnerId?: string,
    public readonly reasonCustomText?: string,
    public readonly refundDestination?: 'wallet' | 'card',
  ) {}
}

export class TransferEventOwnershipAction {
  static readonly type = '[DetailEvents] TransferEventOwnershipAction';

  constructor(public eventId: string, public nextOwnerId: string) {}
}
